import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { getCurrentUser, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { CargueV, CargueService } from '../services/cargue-lifeMiles.service';

@Component({
    selector: 'app-cargue-lifeMiles',
    templateUrl: './cargue-lifeMiles.component.html',
    styleUrls: ['./cargue-lifeMiles.component.scss'],
    styles: [
    `
    @media only screen and (max-width: 500px) {
        .card-body {
            flex-wrap: wrap
        }
        }
        `
    ]
})
export class CargueLifeMilesComponent implements OnInit {
    file: File;
    recordsToSend: number = 1000; //--> No de registros que se enviarán en cada request
    reader = new FileReader();
    isFileLoaded: boolean = false
    textFileLoaded: String
    lastTextFileLoaded: String
    csvMatriz: string[] = [];
    csvHeader: string[] = [];
    parsedInfo: any[] = []
    incorrectInfo: any[] = []
    inputFile: HTMLInputElement


    cargueForm: FormGroup = new FormGroup({
        periodo: new FormControl('', [Validators.required, Validators.pattern(/^.{4,6}$/)]
        ),
    })
    constructor(private notificationService: NotificationHelper,
        private activatedRoute: ActivatedRoute,
        private helpers: HelpersService,
        private cargueService: CargueService,

    ) {
        this.reader.addEventListener('load', (event) => {
            showSpinner()
            this.textFileLoaded = this.reader.result ? this.reader.result as string : "";
            this.csvMatriz = this.textFileLoaded.split(/\r\n|\n/)
            try {
            this.onLoadFile()
            } catch (error: any) {
            this.notificationService.errorMessage(error.message)
            }
            hideSpinner()
        });
        const data = this.activatedRoute.snapshot.data
        if (data.title) {
            this.helpers.setTitle(data.title);
        }
    } 
    onSelectFile(e: HTMLInputElement) {
    
        this.parsedInfo = []
        this.incorrectInfo = []
    
        showSpinner()
        this.inputFile = e
        const files = this.inputFile.files;
        if (files && files.length) {
        this.reader.readAsText(files[0]);
        } else {
        this.notificationService.errorMessage("No se seleccionó ningún archivo.");
        }
        hideSpinner();
    }
	onLoadFile() {
        showSpinner();
        if (this.csvMatriz == undefined || this.csvMatriz.length <= 0) {
        throw new Error("Este archivo no contiene datos.");
        }
        //Sacar el primer registro (debe contener los encabezados)
        const shift = this.csvMatriz.shift();
        if (!shift) {
        throw new Error("Error eliminando encabezados")
        }
        //Obtenemos el header
        this.csvHeader = shift.replace(/"/g, '').toUpperCase().split(/[,;]/);
        //Validamos el header
        if (!(this.csvHeader[0].toUpperCase().trim() === "MEMBERSHIP NUMBER" &&
            this.csvHeader[1].toUpperCase().trim() === "DOCUMENT NUMBER" &&
            this.csvHeader[2].toUpperCase().trim() === "TRANSACTION DATE" &&
            this.csvHeader[3].toUpperCase().trim() === "PROCESS DATE" &&
            this.csvHeader[4].toUpperCase().trim() === "POINT TYPE" &&
            this.csvHeader[5].toUpperCase().trim() === "POINT TYPE NAME" &&
            this.csvHeader[6].toUpperCase().trim() === "BONUS CODE" &&
            this.csvHeader[7].toUpperCase().trim() === "BONUS NAME" &&
            this.csvHeader[8].toUpperCase().trim() === "TRANSACTION TYPE" &&
            this.csvHeader[9].toUpperCase().trim() === "GHOST" &&
            this.csvHeader[10].toUpperCase().trim() === "NO. VOUCHER" &&
            this.csvHeader[11].toUpperCase().trim() === "ORIGIN VOUCHER" &&
            this.csvHeader[12].toUpperCase().trim() === "AUTHORIZATION NUMBER" &&
            this.csvHeader[13].toUpperCase().trim() === "ORIGIN AUTHORIZATION NUMBER" &&
            this.csvHeader[14].toUpperCase().trim() === "LOCAL AMOUNT" &&
            this.csvHeader[15].toUpperCase().trim() === "MILES" &&
            this.csvHeader[16].toUpperCase().trim() === "EXCHANGE RATE" &&
            this.csvHeader[17].toUpperCase().trim() === "MILE PRICE" &&
            this.csvHeader[18].toUpperCase().trim() === "STORE CODE" &&
            this.csvHeader[19].toUpperCase().trim() === "STORE NAME" &&
            this.csvHeader[20].toUpperCase().trim() === "CASHIER CODE" &&
            this.csvHeader[21].toUpperCase().trim() === "REWARD CODE" &&
            this.csvHeader[22].toUpperCase().trim() === "ACTIVITY NUMBER" &&
            this.csvHeader[23].toUpperCase().trim() === "ACTIVITY REFERENCE NUMBER" &&
            this.csvHeader[24].toUpperCase().trim() === "SENDER CODE"
            )
        ){
        throw new Error("Este archivo no tiene el formato requerido.")
        }
        if (this.csvMatriz.length <= 0) {
        throw new Error("El archivo tiene el formato, pero no tiene registros.");
        }
    
        this.csvMatriz.forEach((value, index) => {
            const split = value.replace(/"/g, '').toUpperCase().split(/[,;]/);
            //Validamos que el registro tenga la cantidad de columnas esperadas
            if (split.length === 25) {
            const item: CargueV = {
                membershipNumber: split[0]?.trim() || "",
                documentNumber: split[1]?.trim() || "",
                transactionDate: split[2]?.trim() || "",
                processDate: split[3]?.trim() || "",
                pointType: split[4]?.trim() || "",
                pointTypeName: split[5]?.trim() || "",
                bonusCode: split[6]?.trim() || "",
                bonusName: split[7]?.trim() || "",
                transactionType: split[8]?.trim() || "",
                ghost: split[9]?.trim() || "",
                noVoucher: split[10]?.trim() || "",
                originVoucher: split[11]?.trim() || "",
                authorizationNumber: split[12]?.trim() || "",
                originAuthorizationNumber: split[13]?.trim() || "",
                localAmount: split[14]?.trim() || "",
                miles: split[15]?.trim() || "",
                exchangeRate: split[16]?.trim() || "",
                milePrice: split[17]?.trim() || "",
                storeCode: split[18]?.trim() || "",
                storeName: split[19]?.trim() || "",
                cashierCode: split[20]?.trim() || "",
                rewardCode: split[21]?.trim() || "",
                activityNumber: split[22]?.trim() || "",
                activityReferenceNumber: split[23]?.trim() || "",
                senderCode: split[24]?.trim() || "",
            };
            if (
                item.membershipNumber
            ) {
                this.parsedInfo.push(item);
            } else {
                this.incorrectInfo.push(item);
            }
            } else {
            console.warn(`Registro en la línea ${index + 1} no tiene el formato esperado.`);
            }
        });
    
        if (this.incorrectInfo.length > 0) {
        this.notificationService.warningMessage(`Se encontraron ${this.incorrectInfo.length} registros no válidos.`)
        } else if(this.parsedInfo.length > 0) {
        this.notificationService.infoMessage(`Se encontraron ${this.parsedInfo.length} registros válidos.`)
        this.enableSendButton()
        }
        hideSpinner()
    }
    
    disableButtonAndDeleteLoadedInfo() {
        this.parsedInfo = [];
        this.csvMatriz = [];
        this.csvHeader = [];
        this.isFileLoaded = false;
        this.incorrectInfo = []
    }
    
    enableSendButton() {
        this.isFileLoaded = true;
    }
    ngOnInit(): void {

    }
    onResetForm() {
    this.cargueForm.reset();
    }

    ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';
    for (let index in headerList) {
    row += headerList[index] + ';';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
        let line = '';

    for (let index in headerList) {
        let head = headerList[index];
        line +=  array[i][head]+';';
    }

    str += line + '\r\n';
    }
    return str;
    }

    doFile(data, filename='data') {
    let csvData = this.ConvertToCSV(data, Object.keys(data[0]));
    let dataFile = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    return dataFile
    }

    async onSubmit(): Promise<void> {
        if (this.parsedInfo.length > 0) {
        const divisor = this.parsedInfo.length / this.recordsToSend;
        let dividedData: any[] = [];
    
        for (let i = 0; i < divisor; i++) {
            const element = this.parsedInfo.slice(i * this.recordsToSend, (i + 1) * this.recordsToSend);
            dividedData.push(element)
        }
        let contador= 1;
        for(let element of   dividedData){
            let porcentaje = Math.round((contador / dividedData.length) * 100);
            showSpinner(`Cargando Registros  ${porcentaje} %...`);
            try {
            const usuario = getCurrentUser();
            const empresa = usuario ? usuario.c_emp : 'JA';
            const res = await this.cargueService.cargue(empresa || 'JA', element);
            
            if(!res.success) {
                this.notificationService.errorMessage(res.message);
                hideSpinner();
                return;
            }
            } catch (error) {
            this.notificationService.errorMessage("Ocurrio un error desconocido.")
            hideSpinner();
            return;
            }
            contador++;
        }
        hideSpinner()
        this.notificationService.successMessage("Cargo correctamente")
        this.isFileLoaded = false;
        location.reload()
        } else {
        this.notificationService.infoMessage("No hay nada que enviar")
        }
        
        this.inputFile.value = ""
    }


}
